import React from 'react'
import { themeColor } from '@edulastic/colors'

const CONTENT_LINE_HEIGHT = '22px'

const contentRowStyle = {
  alignItems: 'flex-start',
  display: 'flex',
  gap: 8,
}

const closeButtonStyle = {
  alignSelf: 'flex-start',
  background: 'transparent',
  border: 0,
  color: '#5b6573',
  cursor: 'pointer',
  flexShrink: 0,
  fontSize: 22,
  height: CONTENT_LINE_HEIGHT,
  lineHeight: CONTENT_LINE_HEIGHT,
  margin: 0,
  minHeight: 'unset',
  minWidth: 'unset',
  outline: 'none',
  padding: 0,
  WebkitAppearance: 'none',
  width: 22,
}

const footerButtonBaseStyle = {
  outline: 'none',
}

const backButtonStyle = {
  ...footerButtonBaseStyle,
  marginLeft: 0,
  marginRight: 0,
  padding: '4px',
}

const nextButtonStyle = {
  ...footerButtonBaseStyle,
  padding: '4px',
}

const focusVisibleProps = {
  onFocus: (event) => {
    event.currentTarget.style.outline = `2px solid ${themeColor}`
    event.currentTarget.style.outlineOffset = '2px'
  },
  onBlur: (event) => {
    event.currentTarget.style.outline = ''
    event.currentTarget.style.outlineOffset = ''
  },
}

const ActionHubJoyrideTooltip = ({
  backProps,
  closeProps,
  continuous,
  isLastStep,
  primaryProps,
  step,
  tooltipProps,
  index,
}) => {
  const { content, hideBackButton, hideCloseButton, hideFooter, styles } = step
  const { back, close, last, next } = step.locale || {}
  const primaryLabel = continuous ? (isLastStep ? last : next) : close
  const { ref: joyrideTooltipRef, ...restTooltipProps } = tooltipProps
  const showBackButton = index > 0 && !hideBackButton

  const contentStyle = {
    ...styles.tooltipContent,
    flex: 1,
    lineHeight: CONTENT_LINE_HEIGHT,
    minWidth: 0,
    padding: 0,
    paddingTop: 0,
  }

  const footerStyle = {
    ...styles.tooltipFooter,
    alignItems: 'flex-start',
    display: 'flex',
    justifyContent: showBackButton ? 'space-between' : 'flex-end',
    width: '100%',
  }

  return (
    <div
      {...restTooltipProps}
      ref={joyrideTooltipRef}
      style={{ ...styles.tooltip, textAlign: 'left' }}
    >
      <div style={contentRowStyle}>
        <div style={contentStyle}>{content}</div>
        {!hideCloseButton && (
          <button
            type="button"
            {...closeProps}
            {...focusVisibleProps}
            style={{ ...styles.buttonClose, ...closeButtonStyle }}
          >
            <span aria-hidden="true">×</span>
          </button>
        )}
      </div>
      {!hideFooter && (
        <div style={footerStyle}>
          {showBackButton && (
            <button
              type="button"
              {...backProps}
              {...focusVisibleProps}
              style={{ ...styles.buttonBack, ...backButtonStyle }}
            >
              {back}
            </button>
          )}
          <button
            type="button"
            {...primaryProps}
            {...focusVisibleProps}
            style={{ ...styles.buttonNext, ...nextButtonStyle }}
          >
            {primaryLabel}
          </button>
        </div>
      )}
    </div>
  )
}

export default ActionHubJoyrideTooltip
